import React from 'react';

function Arrow({ dir }) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"
         strokeLinecap="round" strokeLinejoin="round" className="w-3.5 h-3.5">
      <path d={dir === 'left' ? 'M15 18l-6-6 6-6' : 'M9 18l6-6-6-6'} />
    </svg>
  );
}

export default function Pagination({ page, totalPages, total, label = 'entries', onPage, className = '' }) {
  if (totalPages <= 1) return null;

  return (
    <div className={`flex items-center justify-between gap-4 ${className}`}>
      <button
        onClick={() => onPage(Math.max(1, page - 1))}
        disabled={page === 1}
        className="btn-secondary text-sm py-1.5 px-3.5 disabled:opacity-35"
      >
        <Arrow dir="left" />
        Previous
      </button>

      <span className="text-sm text-gray-500 text-center">
        <span className="text-gray-300 font-medium tabular-nums">{page}</span>
        <span className="mx-1.5 text-gray-700">/</span>
        <span className="tabular-nums">{totalPages}</span>
        {total != null && (
          <span className="hidden sm:inline text-gray-600"> · {total} {label}</span>
        )}
      </span>

      <button
        onClick={() => onPage(Math.min(totalPages, page + 1))}
        disabled={page === totalPages}
        className="btn-secondary text-sm py-1.5 px-3.5 disabled:opacity-35"
      >
        Next
        <Arrow dir="right" />
      </button>
    </div>
  );
}
